angular.module('gym.grading').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.grading.grading_events', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.grading.grading_events.list', {
    url: '/grading_events',
    template: require('templates/gyms/grading/grading_events/index.html.slim')
  }).state('gym.grading.grading_events.new', {
    url: '/grading_events/new?member_style_ids?isNewGrading',
    template: require('templates/gyms/grading/grading_events/edit.html.slim')
  }).state('gym.grading.grading_events.edit', {
    url: '/grading_events/:gradingEventId/edit',
    template: require('templates/gyms/grading/grading_events/edit.html.slim')
  }).state('gym.grading.grading_events.show', {
    url: '/grading_events/:gradingEventId',
    template: require('templates/gyms/grading/grading_events/show.html.slim')
  }).state('gym.grading.grading_events.bulk_enrol', {
    url: '/grading_events/:gradingEventId/bulk_enrols/new?report_id&style_id',
    template: require('templates/gyms/grading/grading_events/bulk_enrol.html.slim')
  }).state('gym.grading.grading_events.event_messages', {
    url: '/grading_events/:gradingEventId/messages',
    template: require('templates/gyms/grading/grading_events/messages.html.slim')
  }).state('gym.grading.grading_events.new_message', {
    url: '/grading_events/:gradingEventId/messages/new',
    controller: 'SendGradingEventMessageCtrl',
    template: require('templates/gyms/grading/grading_events/new_message.html.slim'),
    resolve: {
      gradingEvent: ["$stateParams", "GradingEvents", function($stateParams, GradingEvents) {
        return GradingEvents.get($stateParams.gradingEventId);
      }]
    }
  });
}]);
